import React from "react";
import { parseReplace } from "components";
import { CmsContentElement } from "../../cmscontent.types";
import { DomElement, attributesToProps, domToReact } from "html-react-parser";

export const CmsContent_Name_H3: CmsContentElement = [
  "h3",
  (domNode: DomElement) =>
    domNode?.children ? (
      <h3 {...attributesToProps(domNode.attribs)}>{domToReact(domNode.children, { replace: parseReplace })}</h3>
    ) : null,
] as CmsContentElement;
